import { AppNS } from 'app';

export const ifAgencyCompletedFirstMilestone = (
  userData: AppNS.User
): boolean => {
  if (userData.onboardingStep === 'profile_completed') {
    return true;
  }
  return false;
};

export const ifAgencyDuringOnboarding = (userData: AppNS.User): boolean => {
  if (
    userData.onboardingStep === 'staff_members' ||
    userData.onboardingStep === 'agency_profile' ||
    userData.onboardingStep === 'documents'
  ) {
    return true;
  }
  return false;
};
